import { ILocalizationMap } from './SuiteHeader.types';

export const msGridUnit = 8;
export const tenantBrandingHeight = 24;
export const tenantBrandingBreakpoint = msGridUnit * 40;
export const appBrandingColor = '#1451B8';
export const appBrandingBreakpoint = 426;
export const panelPadding = msGridUnit * 1.25;
export const defaultForegroundColor = '#616161';
export const hoverForegroundColor = '#252423';
export const defaultBackgroundColor = '#F3F2F1';
export const hoverBackgroundColor = '#EDEBE9';
export const activeBackgroundColor = '#E1DFDD';
export const waffleIconColor = '#000000';
export const wafflePrimaryColor = '#106EBE';
export const linkColor = '#0078d4';
export const linkHoverColor = '#000000';
export const linkPadding = msGridUnit / 1.6;
export const buttonRightMargin = msGridUnit / 1.6;

export const ME_CONTROL_CDN = 'https://amcdn.msftauth.net/meversion?';
export const PARTNER_ID = 'AADMyStar';

export const defaultLocalizationMap: ILocalizationMap = {
  apps: 'Apps',
  closePanelAriaLabel: 'Close',
  tenantBrandingImageAlt: 'Tenant Branding',
  organizations: 'Switch organizations',
  switchOrgIntroText: "Switch the organization you'd like to switch to.",
  loadingOrganizations: 'Loading organizations',
  organizationsEmpty: 'Your account does not belong to any other organizations',
  finishLoading: 'Finished loading',
  organizationError: 'Cannot get organizations, please refresh and try again',
  currentOrganizationTitle: 'Currently in',
  otherOrganizationsTitle: 'Other organizations you belong to',
  manageOrganizations: 'Manage organizations',
  helpPanelHeaderText: 'Help',
  viewApps: 'View Apps',
  helpPanelTermsOfUseLink: 'Terms of use',
  helpPanelPrivacyLink: 'Privacy',
  accessibilityLink: 'Accessibility',
  accountManager: 'Account manager',
  switchOrganization: 'Switch organization',
  moreOptions: 'More Options',
  leaveNewExp: 'Leave new experience',
  waffleNotAvailableHeader: 'App launcher is not available',
  waffleNotAvailableDescription:
    'Your organization might have Conditional Access policy enforced on Office 365 apps or you are signed in as the guest user'
};
